import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Linkedin, Facebook, Instagram } from 'lucide-react';
import { contact, footerNav } from '../../data/site';
import logoLight from '../../assets/brand/logo-light.png';

const social = [
  { href: contact.linkedin, Icon: Linkedin, label: 'LinkedIn' },
  { href: contact.facebook, Icon: Facebook, label: 'Facebook' },
  { href: contact.instagram, Icon: Instagram, label: 'Instagram' },
];

const Footer = () => (
  <footer className="bg-ink text-paper fieldgrid">
    <div className="container mx-auto px-5 md:px-8 pt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        {/* Brand - the light mark, on the dark ground it was drawn for */}
        <div className="lg:col-span-2 max-w-sm">
          <Link to="/" className="inline-block" aria-label="Annpriya - home">
            <img src={logoLight} alt="Annpriya" className="h-9 w-auto block" />
          </Link>
          <p className="mt-5 text-paper/55 leading-relaxed text-[15px]">
            Pesticide-free hydroponic and aeroponic produce from Jaipur, grown on an automated
            nutrient system that measures before it acts.
          </p>

          <div className="mt-7 space-y-3 text-[15px]">
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-lime shrink-0 mt-1" />
              <span className="text-paper/70">{contact.address}</span>
            </div>
            <a href={contact.emailHref} className="flex items-start gap-3 group">
              <Mail className="w-4 h-4 text-lime shrink-0 mt-1" />
              <span className="text-paper/70 group-hover:text-lime transition-colors break-all">
                {contact.email}
              </span>
            </a>
            <a href={contact.phoneHref} className="flex items-start gap-3 group">
              <Phone className="w-4 h-4 text-lime shrink-0 mt-1" />
              <span className="text-paper/70 group-hover:text-lime transition-colors">
                {contact.phone}
              </span>
            </a>
          </div>

          <div className="flex gap-2.5 mt-7">
            {social.map(({ href, Icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-10 h-10 rounded-full grid place-items-center bg-white/[0.06] ring-1 ring-white/10 text-paper/70 hover:bg-lime hover:text-ink hover:ring-lime transition-colors"
              >
                <Icon className="w-[18px] h-[18px]" />
              </a>
            ))}
          </div>
        </div>

        {footerNav.map((col) => (
          <div key={col.heading}>
            <h3 className="label text-lime">{col.heading}</h3>
            <ul className="mt-5 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.name}>
                  <Link
                    to={l.path}
                    className="text-paper/60 hover:text-lime transition-colors text-[15px]"
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
        <p className="text-paper/40 text-[13px]">
          © {new Date().getFullYear()} Annpriya Organics Private Limited. All rights reserved.
        </p>
        <p className="label text-paper/30">
          Nutrient system architecture · SIET &middot; Keystride
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
